// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles */
body {
  margin: 0;
  padding: 0;
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #212529;
  background-color: #f8f9fa;
}

/* Scrollbar styles */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* Material-UI overrides */
.MuiButton-root {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  letter-spacing: 0.3px;
  transition: all 0.2s ease-in-out !important;
}

.MuiButton-contained {
  box-shadow: none !important;
}

.MuiButton-contained:hover {
  box-shadow: 0 4px 12px rgba(67, 97, 238, 0.3) !important;
  transform: translateY(-1px);
}

.MuiCard-root {
  border-radius: 12px !important;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05) !important;
  transition: transform 0.2s, box-shadow 0.2s !important;
}

.MuiCard-root:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px 0 rgba(0, 0, 0, 0.1) !important;
}

.MuiPaper-elevation1 {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.05) !important;
}

.MuiPaper-rounded {
  border-radius: 12px !important;
}

.MuiInputBase-root {
  border-radius: 8px !important;
}

.MuiOutlinedInput-root {
  background-color: #fff;
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.fade-in {
  animation: fadeIn 0.3s ease-out forwards;
}

/* Utility classes */
.shadow-sm {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.05) !important;
}

.shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}

.rounded-lg {
  border-radius: 12px !important;
}

.rounded-xl {
  border-radius: 16px !important;
}

/* Responsive typography */
h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  line-height: 1.3;
  margin-top: 0;
  margin-bottom: 0.5em;
}

/* Form elements */
.MuiFormLabel-root {
  margin-bottom: 4px !important;
  display: block;
  font-weight: 500 !important;
  color: #495057 !important;
}

/* Table styles */
.MuiTable-root {
  min-width: 650px;
}

.MuiTableContainer-root {
  border-radius: 12px !important;
  overflow: hidden;
}

.MuiTableCell-head {
  font-weight: 600 !important;
  background-color: #f8f9fa;
}

/* Card actions */
.MuiCardActions-root {
  padding: 16px 24px !important;
  background-color: #f8f9fa;
  border-bottom-left-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
}

/* Alert styles */
.MuiAlert-root {
  border-radius: 8px !important;
  font-weight: 500;
}

/* Dialog styles */
.MuiDialog-paper {
  border-radius: 16px !important;
  padding: 24px;
}

/* Tab styles */
.MuiTabs-indicator {
  height: 3px !important;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

/* Skeleton loading */
.MuiSkeleton-root {
  border-radius: 8px !important;
}

/* Tooltip styles */
.MuiTooltip-tooltip {
  border-radius: 6px !important;
  padding: 6px 12px !important;
  font-size: 0.8rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,SAAS;EACT,UAAU;EACV;kFACgF;EAChF,mCAAmC;EACnC,kCAAkC;EAClC,cAAc;EACd,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wDAAwD;EACxD,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,uDAAuD;EACvD,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,mFAAmF;AACrF;;AAEA;EACE,4FAA4F;AAC9F;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;AAC9B","sourcesContent":["/* Base styles */\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #212529;\n  background-color: #f8f9fa;\n}\n\n/* Scrollbar styles */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n/* Material-UI overrides */\n.MuiButton-root {\n  border-radius: 8px !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  letter-spacing: 0.3px;\n  transition: all 0.2s ease-in-out !important;\n}\n\n.MuiButton-contained {\n  box-shadow: none !important;\n}\n\n.MuiButton-contained:hover {\n  box-shadow: 0 4px 12px rgba(67, 97, 238, 0.3) !important;\n  transform: translateY(-1px);\n}\n\n.MuiCard-root {\n  border-radius: 12px !important;\n  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05) !important;\n  transition: transform 0.2s, box-shadow 0.2s !important;\n}\n\n.MuiCard-root:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px 0 rgba(0, 0, 0, 0.1) !important;\n}\n\n.MuiPaper-elevation1 {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.05) !important;\n}\n\n.MuiPaper-rounded {\n  border-radius: 12px !important;\n}\n\n.MuiInputBase-root {\n  border-radius: 8px !important;\n}\n\n.MuiOutlinedInput-root {\n  background-color: #fff;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.fade-in {\n  animation: fadeIn 0.3s ease-out forwards;\n}\n\n/* Utility classes */\n.shadow-sm {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.05) !important;\n}\n\n.shadow-md {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;\n}\n\n.rounded-lg {\n  border-radius: 12px !important;\n}\n\n.rounded-xl {\n  border-radius: 16px !important;\n}\n\n/* Responsive typography */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600;\n  line-height: 1.3;\n  margin-top: 0;\n  margin-bottom: 0.5em;\n}\n\n/* Form elements */\n.MuiFormLabel-root {\n  margin-bottom: 4px !important;\n  display: block;\n  font-weight: 500 !important;\n  color: #495057 !important;\n}\n\n/* Table styles */\n.MuiTable-root {\n  min-width: 650px;\n}\n\n.MuiTableContainer-root {\n  border-radius: 12px !important;\n  overflow: hidden;\n}\n\n.MuiTableCell-head {\n  font-weight: 600 !important;\n  background-color: #f8f9fa;\n}\n\n/* Card actions */\n.MuiCardActions-root {\n  padding: 16px 24px !important;\n  background-color: #f8f9fa;\n  border-bottom-left-radius: 12px !important;\n  border-bottom-right-radius: 12px !important;\n}\n\n/* Alert styles */\n.MuiAlert-root {\n  border-radius: 8px !important;\n  font-weight: 500;\n}\n\n/* Dialog styles */\n.MuiDialog-paper {\n  border-radius: 16px !important;\n  padding: 24px;\n}\n\n/* Tab styles */\n.MuiTabs-indicator {\n  height: 3px !important;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n/* Skeleton loading */\n.MuiSkeleton-root {\n  border-radius: 8px !important;\n}\n\n/* Tooltip styles */\n.MuiTooltip-tooltip {\n  border-radius: 6px !important;\n  padding: 6px 12px !important;\n  font-size: 0.8rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
